"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkingHoursTemplate_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ProviderWorkingShift_1 = require("./ProviderWorkingShift");
var WorkingHoursTemplateDate_1 = require("./WorkingHoursTemplateDate");
var WorkingHoursTemplate_Factory = /** @class */ (function () {
    function WorkingHoursTemplate_Factory() {
    }
    WorkingHoursTemplate_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Name: model.Name,
            ProviderWorkingShifts: model.ProviderWorkingShifts && model.ProviderWorkingShifts.map(function (i) { return ProviderWorkingShift_1.ProviderWorkingShift_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            WorkingHoursTemplateDates: model.WorkingHoursTemplateDates && model.WorkingHoursTemplateDates.map(function (i) { return WorkingHoursTemplateDate_1.WorkingHoursTemplateDate_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    WorkingHoursTemplate_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Name: model.Name,
            ProviderWorkingShifts: model.ProviderWorkingShifts && model.ProviderWorkingShifts.map(function (i) { return ProviderWorkingShift_1.ProviderWorkingShift_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            WorkingHoursTemplateDates: model.WorkingHoursTemplateDates && model.WorkingHoursTemplateDates.map(function (i) { return WorkingHoursTemplateDate_1.WorkingHoursTemplateDate_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return WorkingHoursTemplate_Factory;
}());
exports.WorkingHoursTemplate_Factory = WorkingHoursTemplate_Factory;
